import React, { useState } from "react";
import Select from "react-select";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Form } from "react-bootstrap";

import { Common, Array, SUCCESS } from "../../../helper";
import * as commonApi from "../../../api/commonApi";
import { styles } from "../"
import { isEmptyObject } from "../../../util";
import { success } from "../../Shared";

const CreateClass = (props) => {
  const { setcreateClass, getData } = props;
  const [selectedYear, setSelectedYear] = useState(null)
  const [errMessage, setErrMessage] = useState(false);
  const [year, setYear] = useState("");

  const SignupSchema = Yup.object().shape({
    className: Yup.string().trim(" ").max(25, Common.LengthRestriction).required(Common.Required),
    myRadio: Yup.string().required(Common.Required),
  });

  const addClass = async (newClass) => {
    const addClass = await commonApi.addClass(newClass);
    if (!isEmptyObject(addClass)) {
      setcreateClass(false);
      success(SUCCESS.CLASS_CREATED);
      getData();
    }
  }

  return (
    <Formik
      initialValues={{ className: "", myRadio: "", selectedYear: "" }}
      validationSchema={SignupSchema}
      validate={() => {
        const errors = {};
        return errors;
      }}
      onSubmit={(values) => {
        if (year === undefined || year === "" || year === null) {
          setErrMessage(true)
        }
        else {
          const newClass = {
            name: values.className,
            isRegistrationGroup: values.myRadio === Common.Registrationgroup ? true : false,
            year: selectedYear.value
          };
          addClass(newClass);
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form
          onSubmit={handleSubmit}
          style={styles.modal_form}
        >
          <Form.Group
            className="mb-3 "
            controlId="formBasicEmail"
          >
            <Form.Label>
              {Common.ClassName}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder={Common.ClassName}
              name={Common.Classname}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.className}
            />
            {errors.className &&
              touched.className &&
              errors.className && (
              <small style={styles.error_message}>
                {errors.className}
              </small>
            )}
          </Form.Group>
          <Form.Group style={styles.radioMargin}>
            <label >{Common.Year} </label>

            <Select
              defaultValue={selectedYear}
              onChange={(e) => {
                setSelectedYear(e)
                setErrMessage(false)
                setYear(e.value)
              }}
              options={Array.Years.filter(year => year !== Common.All).map(year => ({ value: year, label: `Year ${year}` }))}
              placeholder="please select"
            />
            {errMessage && (<small className="text-danger">{"PleaseSelect year"}</small>)}
          </Form.Group>
          <Form.Group style={styles.radioMargin}>
            <div style={styles.radioMargin}>
              <label>
                <input
                  type="radio"
                  name="myRadio"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={Common.Registrationgroup}
                  style={styles.radioPadding}
                />&nbsp;
                {Common.RegistrationGroup}
              </label>&nbsp;
              <label>
                <input
                  type="radio"
                  name="myRadio"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={Common.TeachingGroup_}
                  style={styles.radioPadding}
                />&nbsp;
                {Common.TeachingGroup}
              </label>
            </div>
            {errors.myRadio &&
              touched.myRadio &&
              errors.myRadio && (
              <small style={styles.error_message}>
                {errors.myRadio}
              </small>
            )}
          </Form.Group>
          <Form.Group style={styles.button}>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setcreateClass(false);
              }}
            >
              {Common.Cancel}
            </Button>&nbsp;
            <Button
              type="submit"
              variant="success"
            >
              {Common.AddClass}
            </Button>
          </Form.Group>
        </Form>
      )}
    </Formik>
  )
}

export { CreateClass };
